import { render, staticRenderFns } from "./SeniorCitizenIcon.vue?vue&type=template&id=a1f3573e"
import script from "./SeniorCitizenIcon.vue?vue&type=script&lang=js"
export * from "./SeniorCitizenIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports